import { render, staticRenderFns } from "./turndown.vue?vue&type=template&id=4885149b&scoped=true&"
import script from "./turndown.vue?vue&type=script&lang=js&"
export * from "./turndown.vue?vue&type=script&lang=js&"
import style0 from "./turndown.vue?vue&type=style&index=0&id=4885149b&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4885149b",
  null
  
)

export default component.exports